import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  layout: null,
};
export const layoutSlice = createSlice({
  name: "layout",
  initialState,
  reducers: {
    setLayout: (state, action) => {
      state.layout = action.payload;
    },
    setLogoutLayout: (state, action) => {
      state.layout = null;
    },
  },
});

export const { setLayout, setLogoutLayout } = layoutSlice.actions;

export default layoutSlice.reducer;
